import { setDecompositionTreeMetricFilter as setDecompositionTreeMetricFilterDiagram } from '@process-advisor/process-miner/processMiner/processMiner';
import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';
import { Event } from '@process-advisor/process-miner/api/events';

export type Props = ApiMethodBase & {
    metricFilter?: Number,
}

export const applyDecompositionTreeMetricFilter = ({
    metricFilter,
    eventEmitter,
}: Props) => {
    setDecompositionTreeMetricFilterDiagram(metricFilter);
    eventEmitter.emit(Event.applyDecompositionTreeMetricFilter);
};
